import {Component, Input, OnInit} from '@angular/core';
import {WdrRegionsBerichte} from "../../../../../../../model/vorhersagen/wdr-wetterbericht";

@Component({
  selector: 'app-wdr-regionen-bericht',
  templateUrl: './wdr-regionen-bericht.component.html',
  styleUrls: ['../../wetterbericht.component.css']
})
export class WdrRegionenBerichtComponent  {

  @Input() regionenBericht: WdrRegionsBerichte;

  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
}
